import React from 'react';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const StatsLoadingSkeleton = () => (
    <>
        <h1 className="mb-0"><Skeleton width={200} /></h1>
        <div className="mb-2">
            <Skeleton height={38} /> {/* For StatsFilters */}
        </div>
        <ul style={{ height: 500 }} className="d-flex flex-row list-unstyled">
            <li className="me-2">
                <Card className="h-100">
                    <Card.Header>
                        <Skeleton width={200} />
                    </Card.Header>
                    <Card.Body>
                        <Skeleton height={400} />
                    </Card.Body>
                </Card>
            </li>
            <li className="flex-grow-1 ms-2">
                <Card className="h-100">
                    <Card.Header>
                        <Skeleton width={300} />
                    </Card.Header>
                    <Card.Body>
                        <Skeleton height={400} />
                    </Card.Body>
                </Card>
            </li>
        </ul>
    </>
);
